import type { RouteRecordRaw } from 'vue-router';
import { BILLINGDETAIL_ROUTE_NAME } from './consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const billingDetailRoutes: RouteRecordRaw = {
  path: '/billing-detail',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: BILLINGDETAIL_ROUTE_NAME.BILLINGDETAIL,
      path: '',
      component: () => import('./BillingDetail.vue'),
    },
  ],
};

export const billingDetailRedirects: RouteRecordRaw[] = [
  { path: '/billingdetail', redirect: { name: BILLINGDETAIL_ROUTE_NAME.BILLINGDETAIL } },
];
